import { ControlSection } from '../types/quality'

export interface QualityTemplate {
  id: string
  label: string
  description: string
  /** Section titles and their control points, cloned when a report is created. */
  build: () => ControlSection[]
}

function section(
  key: string,
  title: string,
  kind: ControlSection['kind'],
  points: string[],
): ControlSection {
  return {
    id: `sec-${key}-${Date.now()}`,
    title,
    kind,
    points: points.map((pointTitle, index) => ({
      id: `kp-${key}-${index}-${Date.now()}`,
      title: pointTitle,
      status: 'pending',
      requiresPhoto: true,
    })),
  }
}

export const qualityTemplates: QualityTemplate[] = [
  {
    id: 'charger',
    label: 'Ladeboks',
    description: 'Gruppe, kabelføring, montage og funktionstest',
    build: () => [
      section('lade-proces', 'Ladeboks, proceskontrol', 'Proceskontrol', [
        'Gruppe afsat i tavle',
        'Kabelføring fastgjort',
        'Ladeboks monteret',
      ]),
      section('lade-slut', 'Ladeboks, slutkontrol', 'Slutkontrol', [
        'Funktionstest gennemført',
        'Området ryddet',
      ]),
    ],
  },
  {
    id: 'roof',
    label: 'Tag og asbest',
    description: 'Afspærring, nedtagning, emballering og rengøring',
    build: () => [
      section('tag-proces', 'Tagarbejde, proceskontrol', 'Proceskontrol', [
        'Tag undersøgt før nedtagning',
        'Arbejdsområde afspærret',
        'Plader fjernet og emballeret',
      ]),
      section('tag-slut', 'Tagarbejde, slutkontrol', 'Slutkontrol', [
        'Område rengjort efter fjernelse',
      ]),
    ],
  },
  {
    id: 'installation',
    label: 'Alm. installation',
    description: 'Standard el-installation med proces- og slutkontrol',
    build: () => [
      section('inst-proces', 'Installation, proceskontrol', 'Proceskontrol', [
        'Installation udført efter tegning',
        'Materialer kontrolleret',
      ]),
      section('inst-slut', 'Installation, slutkontrol', 'Slutkontrol', [
        'Måling og test gennemført',
        'Afleveret til kunde',
      ]),
    ],
  },
  {
    id: 'blank',
    label: 'Tom rapport',
    description: 'Start uden kontrolpunkter og byg den selv',
    build: () => [],
  },
]
